// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_51-7";
export var adjustableWidthBorderHeld = "_51-8";
export var arrow = "_51-3";
export var arrowButton = "_51-4";
export var headerCell = "_51-0";
export var help = "_51-2";
export var icon = "_51-1";
export var iconWrapper = "_51-6";
export var noBorder = "_51-b";
export var nonAdjustableWidthBorder = "_51-9";
export var nonAdjustableWidthBorderHeld = "_51-a";
export var textButton = "_51-5";